import React from "react"
import { FormattedMessage } from "gatsby-plugin-intl"
import TextInput from "@tmu/components/common/TextInput"
import { Spacer } from "@tmu/src/global/page-addons/detail-page.styles"
import { StyledEmailLabel } from "../DonationForm/index.styles"
import { REQUIRED_FIELD_SYMBOL } from "@tmu/apollo/constants"

const Attendees = ({
  quantity,
  values,
  errors,
  handleChange,
  handleBlur,
  isWide,
  isTablet,
  isDesktop,
  formatMessage,
}) => {
  return Array.from({ length: quantity }).map((_, index) => (
    <React.Fragment key={index}>
      <p>
        <FormattedMessage
          id="dashboard::table::ticket"
          defaultMessage="Ticket"
        />
        {index + 1}
      </p>
      <TextInput
        newDesign
        data-testid={`input-attendeeFirstName-${index}`}
        id={`attendeeFirstName_${index}`}
        name={`attendeeFirstName_${index}`}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values[`attendeeFirstName_${index}`] || ""}
        label={`${formatMessage({
          id: "signUp::firstName",
          defaultMessage: "First Name",
        })}${REQUIRED_FIELD_SYMBOL}`}
        placeholder={formatMessage({
          id: "signUp::firstName",
          defaultMessage: "First Name",
        })}
        error={errors[`attendeeFirstName_${index}`]}
        touched={true}
      />
      <Spacer bottom={isWide ? 2.5 : isTablet || isDesktop ? 2 : 1.5} />
      <TextInput
        newDesign
        data-testid={`input-attendeeLastName-${index}`}
        id={`attendeeLastName_${index}`}
        name={`attendeeLastName_${index}`}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values[`attendeeLastName_${index}`] || ""}
        label={`${formatMessage({
          id: "signUp::lastName",
          defaultMessage: "Last Name",
        })}${REQUIRED_FIELD_SYMBOL}`}
        placeholder={formatMessage({
          id: "signUp::lastName",
          defaultMessage: "Last Name",
        })}
        error={errors[`attendeeLastName_${index}`]}
        touched={true}
      />
      <Spacer bottom={isWide ? 2.5 : isTablet || isDesktop ? 2 : 1.5} />
      <TextInput
        newDesign
        className="mt24"
        data-testid={`input-attendeeEmail-${index}`}
        id={`attendeeEmail_${index}`}
        name={`attendeeEmail_${index}`}
        type="email"
        onChange={(e) => {
          const lowerCaseEmail = e.target.value.toLowerCase()
          handleChange({
            target: {
              name: e.target.name,
              value: lowerCaseEmail,
            },
          })
        }}
        onBlur={handleBlur}
        value={values[`attendeeEmail_${index}`] || ""}
        label={
          <StyledEmailLabel>
            {formatMessage({
              id: "signUp::email",
              defaultMessage: "Email",
            })}
            {REQUIRED_FIELD_SYMBOL}
          </StyledEmailLabel>
        }
        placeholder={formatMessage({
          id: "signUp::email",
          defaultMessage: "Email",
        })}
        error={errors[`attendeeEmail_${index}`]}
        touched={true}
      />
      <Spacer bottom={isWide ? 2.5 : isTablet || isDesktop ? 2 : 1.5} />
    </React.Fragment>
  ))
}

export default Attendees
